import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { FINANCIAL_BOQ_ROUTE } from "@pma/utils/page-routes";

const MainBoQPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Navigate to org BoQ Estimate page
    navigate(FINANCIAL_BOQ_ROUTE);
  }, []);

  // TODO
  // Customize this page with appropriate content
  return <></>;
};

export default MainBoQPage;
